import api from '@/services/api';

const getPerks = () => api()
  .get('perks');

const getPerkFromId = (perkId) => api()
  .get(`perks/${perkId}`);

export {
  getPerks,
  getPerkFromId,
};
